// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

import { useState } from 'react'
import { ListItemContainer, Table, TableData, Text, TextLink } from '../UI/generalLayout/Layout.styled'
import { useAppDispatch } from '../..'
import { ItemInfoContainer, MobileContainer, SwitchContainer, ViewEditContainer } from '../companyListItem/CompanyListItemMobile.styled'
import { StyledSwitch } from '../companyListItem/CompanyListItem.styled'
import { useSelector } from 'react-redux';
import { Auth } from '../../core/http/service/Auth';
import { DependentesService } from '../../core/http/service/DependentesService';
import Colors from '../../constants/Colors'
import GenericModal from '../genericModal/GenericModal'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import EditDependenteModal from '../editDependenteModal/editDependenteModal'
import ActivateInactivateModal from '../activateInactivateModal/ActivateInactivateModal'
import DependentesListaModel from '../../models/dependente/DependentesListaModel';
import * as personActions from "../../store/actions/person";
import Company from '../../models/core/company/Company'
import * as collaboratorInitial from "../../store/actions/collaboratorInitial";

// --------------------------------------------------------
// USER LIST ITEM INTERFACE
// --------------------------------------------------------
  
/**
/**
 * A component that renders a User List Item.
 *
 * @param props The component props.
 * @returns The component JSX.
 */

interface ApiResponse {
    success: boolean;
}

const UserListDependenteItem: React.FC<{ item: DependentesListaModel, cpfResponsavel: any }> = ({ item, cpfResponsavel }) => {
    // --------------------------------------------------------
    // USER LIST ITEM PRIVATE DECLARATIONS
    // --------------------------------------------------------    

    const [showModalResetarSenha, setShowModalResetarSenha] = useState(false)
    const [showModalEditDependente, setShowModalEditDependente] = useState(false);
    const [showModalInactivate, setShowModalInactivate] = useState(false);
    const [showModalSuccess, setShowModalSuccess] = useState(false);
    const [showModalError, setShowModalError] = useState(false);   
    const [titleError, setTitleError] = useState("");
    const { isMobile } = useResponsiveInfo()
    const dispatch = useAppDispatch()
    const [profile, setProfile] = useState<DependentesListaModel>(item);
    const [personId, setPersonId] = useState("");
    const [checked, setChecked] = useState(true);
    const pessoaDependente = useSelector((state: any)=> state.person.pessoaDependente)
    const currentCompany: Company = useSelector((state: any) => state.login.currentCompany);  
    
    const onConfirmResetPassword = async ()=>{
        
        try {

            if(profile && profile?.solicitacaoRedefinirSenha){
                setTitleError("Ocorreu um erro ao solicitar a redefinição de senha. Já houve uma solicitação anterior, use o CPF como senha.")
                setShowModalResetarSenha(false);
                setShowModalError(true);
                
                return;
            }else{
                setShowModalError(false);
            }


            var cpf = profile.cpf.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
            //RESETAR SENHA    
            if (cpf) {
                const service = new Auth();
                service.RedefinePassword({ User: cpf })
                    .then(async result => {

                        const data = result.data as any;
            
                        if (data.success) {
                            
                            console.log("Password reset successful.");
                            setShowModalResetarSenha(false);
                            setShowModalSuccess(true);

                            if (currentCompany && cpfResponsavel) {             
                                var body = {
                                  EmpresaId: currentCompany.id,
                                  Cpf:  cpfResponsavel,
                                }
                                await dispatch(collaboratorInitial.getDependente(body)); 
                            }

                        } else {
                            setShowModalResetarSenha(false)
                            console.error("Password reset failed:", data.errors[0]);
                            setTitleError('Ocorreu um erro ao solicitar a redefinição de senha. Já houve uma solicitação anterior, use o CPF como senha.');
                            setShowModalError(true);
                        }

                    })
                    .catch(error => {                        
                        console.error("Erro na chamada:", error); 
                        setTitleError('Erro ao atualizar os dados! Por favor tente mais tarde ou entre em contato com o suporte.');
                        setShowModalError(true);                       
                    });
            }
            
            
        } catch (error) {
            console.log(error)
        }

    }

    const onEditPerson = async (pessoaId: string)=>{
        
        try {  
            await dispatch(personActions.fetchPersonDependente(`${pessoaId}`));           
            setShowModalEditDependente(true);
        } catch (error) {
            console.log(error)
        }

    }

    const onDesativarDependente = async ()=>{
        
        try {      
            const service: DependentesService = new DependentesService();
                if(checked){
                    await service.postInactivate({
                        "id":  personId
                    });

                }else{
                    await service.postActivate({
                        "id": personId
                    });                 

                }

            setShowModalSuccess(true);
            setShowModalInactivate(false);

            if (currentCompany && cpfResponsavel) {                
                await dispatch(collaboratorInitial.getDependente({
                    EmpresaId: currentCompany.id,
                    Cpf:  cpfResponsavel,
                  })); 
            }
                               
        } catch (error) {
            console.log(error)
        }

    }
    
    const maskCPF = (value: string) => {
        return value
          .replace(/\D/g, '')
          .replace(/(\d{3})(\d)/, '$1.$2')
          .replace(/(\d{3})(\d)/, '$1.$2') 
          .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      };

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <ListItemContainer>
                {!isMobile? 
                (<Table key={profile.pessoaId}>
                    <TableData width={'39%'}>
                        <Text>{profile.nome}</Text>
                    </TableData>
                    <TableData width={'22%'}>
                        <Text>{maskCPF(profile.cpf.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'))}</Text>
                    </TableData>
                    <TableData width={'15%'}>
                        <Text>{profile.tipoDependente?.name}</Text>
                    </TableData>                    
                    <TableData width={'10%'} alignRight={false}>
                        <TextLink 
                            style={{ fontWeight: 'bold'}}
                            color={Colors.SPM500}                
                            onClick={() => onEditPerson(`${profile.pessoaId}`)}
                            >
                                EDITAR
                        </TextLink> 
                    </TableData>
                    <TableData width={'20%'} alignRight={false}>
                        <TextLink 
                            style={{ fontWeight: 'bold'}}
                            color={Colors.SPM500}                
                            onClick={() => setShowModalResetarSenha(true)}
                            >
                                REDEFINIR SENHA
                        </TextLink>    
                    </TableData>
                    <TableData width={'20%'} alignRight={false}>
                        <StyledSwitch 
                            style={{ color: Colors.SPM600 }}
                            checked={!profile.inativo}
                            onChange={(event) => {
                                const isChecked = event.target.checked;
                                setShowModalInactivate(true);
                                setPersonId(`${profile.id}`);
                                setChecked(!isChecked);
                            }}
                        />
                    </TableData>
                </Table>
                    ):
                    (    
                    <>
                    <MobileContainer key={profile.pessoaId}>
                        <ItemInfoContainer style={{textAlign: 'start'}}>
                            <Text bold color={Colors.GRAY900}>{profile.nome}</Text>
                            <Text 
                                color={true? '#8D8D8D':Colors.GRAY400} 
                                style={{ fontSize: 14, marginTop: -6 }}
                            >
                                {maskCPF(profile.cpf.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'))}
                            </Text>
                            <Text>{profile.tipoDependente?.name}</Text>
                            <ViewEditContainer style={{width: 200}}>
                                <TextLink 
                                    bold 
                                    color={Colors.SPM500} 
                                    style={{ fontSize: 12 }} 
                                    onClick={() => onEditPerson(`${profile.pessoaId}`)}>
                                    EDITAR
                                </TextLink>
                                <TextLink 
                                    bold 
                                    color={Colors.SPM500} 
                                    style={{ fontSize: 12 }} 
                                    onClick={() => {                                    
                                        setShowModalResetarSenha(true)                                         
                                    }}
                                >
                                    REDEFINIR SENHA
                                </TextLink>
                            </ViewEditContainer>
                        </ItemInfoContainer>
                        <SwitchContainer>
                            <StyledSwitch
                                    sx={{ width: 60 }}
                                    style={{ color: Colors.SPM600, width: 45 }}
                                    checked={!profile.inativo}
                                    onChange={(event) => {
                                        const isChecked = event.target.checked;
                                        setShowModalInactivate(true);
                                        setPersonId(`${profile.id}`);
                                        setChecked(!isChecked);
                                    }}
                                />                    
                        </SwitchContainer>
                    </MobileContainer>     
                    </>          				     
                    )}
            </ListItemContainer> 

            <GenericModal                 
                visible={showModalResetarSenha} 
                onCancel={onConfirmResetPassword } 
                onConfirm={ () => setShowModalResetarSenha(false)} 
                modalTitle={'Você tem certeza de que deseja redefinir a senha deste usuário? A nova senha será o mesmo que o CPF cadastrado.'} 
                modalSubtitle={''} 
                cancelButtonMsg={'Voltar'} 
                confirmButtonMsg={'Redefinir'}                
            />    

            <EditDependenteModal        
                visible={showModalEditDependente}         
                user={''}
                onConfirm={ () => setShowModalEditDependente(false)} 
                modalTitle={'Editar Dependente'} 
                modalSubtitle={''} 
                cancelButtonMsg={'Voltar'} 
                confirmButtonMsg={'Redefinir'}  
                item={pessoaDependente} 
            />  

            <ActivateInactivateModal 
                visible={showModalInactivate}
                onCancel={() => { setShowModalInactivate(false) }}
                onConfirmCancellation={onDesativarDependente} 
                ativarButtonMsg={`Ativar dependente`} 
                inativarButtonMsg={`Inativar dependente`} 
                modalMsg={`Você tem certeza que deseja ${!profile.inativo? 'inativar':'ativar'} esse dependente?`}   
                isActivate={profile.inativo}                  
            />

            <GenericModal                 
                visible={showModalSuccess} 
                onCancel={() => setShowModalSuccess(false)} 
                onConfirm={() => setShowModalSuccess(false)} 
                modalTitle={'Operação concluída com sucesso! Os dados foram atualizados com êxito.'} 
                modalSubtitle={''} 
                cancelButtonMsg={''} 
                confirmButtonMsg={'Ok'}                
            />    

            <GenericModal                 
                visible={showModalError} 
                onCancel={() => setShowModalError(false)} 
                onConfirm={() => setShowModalError(false)} 
                modalTitle={titleError} 
                modalSubtitle={''} 
                cancelButtonMsg={''} 
                confirmButtonMsg={'Ok'}                
            />  
        </>
    )
    // --------------------------------------------------------
}

export default UserListDependenteItem